import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FamilyRestroom as FamilyIcon } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material';

// Styled Components
const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: theme.spacing(2),
  margin: theme.spacing(0.5, 1),
  transition: 'all 0.3s ease',
  position: 'relative',
  overflow: 'hidden',
  backgroundColor: 'transparent',
  
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '0px',
    background: `linear-gradient(to bottom, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    borderRadius: theme.spacing(0, 1, 1, 0),
    transition: 'all 0.3s ease',
  },

  '&.Mui-selected': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    '&::before': {
      width: '4px',
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.primary.main,
    },
    '& .MuiTypography-root': {
      fontWeight: 600,
      background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
    },
  },

  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.05),
    transform: 'translateX(4px)',
    
    '&::before': {
      width: '4px',
    },

    '& .MuiListItemIcon-root': {
      transform: 'scale(1.1)',
      color: theme.palette.primary.main,
    },

    '& .MuiTypography-root': {
      background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
      backgroundClip: 'text',
      WebkitBackgroundClip: 'text',
      color: 'transparent',
    },
  },
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 40,
  transition: 'all 0.3s ease',
  color: theme.palette.text.secondary,
  '& .MuiSvgIcon-root': {
    fontSize: '1.5rem',
  },
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiTypography-root': {
    fontWeight: 400,
    fontSize: '1rem',
    transition: 'all 0.3s ease',
  },
}));

const MyFamilyTreeButton = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSelected = location.pathname === '/my-family-tree';

  const handleClick = () => {
    navigate('/my-family-tree');
  };

  return (
    <StyledListItemButton onClick={handleClick} selected={isSelected}>
      <StyledListItemIcon>
      <FamilyIcon sx={{ fontSize: 32 }} />
      </StyledListItemIcon>
      <StyledListItemText primary="My Family Tree" />
    </StyledListItemButton>
  );
};

export default MyFamilyTreeButton;

